module.exports = __webpack_public_path__ + "static/media/clock.0bf8a5ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/clock.svg
// module id = 829
// module chunks = 21